module.exports = __webpack_public_path__ + "img/AC7F84_78463A_C4AABB_885454-256px.e9eb4b9f.png";